export function userListTableHead () {
	return [
		{
			text	: 'Id',
			align	: 'start',
			value	: 'id'
		},
		{
			text	: 'Full name',
			value	: 'fullName'
		},
		{
			text	: 'E-Mail',
			value	: 'email'
		},
		{
			text	: 'Phone',
			value	: 'phone'
		},
		{
			text	: 'Points',
			value	: 'points'
		},
		{
			text	: 'Country',
			value	: 'country'
		},
		{
			text	: 'Created time',
			value	: 'create_at'
		},
		{
			text	: 'Status',
			value	: 'status'
		},
		{
			text	: 'Actions',
			value	: 'actions',
			sortable: false
		}
	]
}

export function courseListTableHead () {
	return [
		{
			text	: 'Name',
			value	: 'name'
		},
		{
			text	: 'Picture',
			value	: 'picture'
		},
		{
			text	: 'Created time',
			value	: 'createdAt'
		},
		{
			text	: 'Type',
			value	: 'type'
		},
		{
			text	: 'Status',
			value	: 'status',
			sort	: (a, b) => {
				if(!a || !b){
					return 0
				}
				
				const nameA = a.data.title.toLowerCase();
				const nameB = b.data.title.toLowerCase();
				
				if (nameA > nameB) {
					return -1
				}
				
				if (nameA < nameB) {
					return 1
				}
				
				return 0
			}
		},
		{
			text	: 'Actions',
			value	: 'actions',
			sortable: false
		}
	]
}

export function userCourseListTableHead () {
	return [
		{
			text	: 'ID',
			value	: 'id',
			sortable: true
		},
		{
			text	: 'Course ID',
			value	: 'course_id',
			sortable: true
		},
		{
			text	: 'Name',
			value	: 'name',
			sortable: true
		},
		{
			text	: 'Package',
			value	: 'package',
			sortable: true
		},
		{
			text	: 'Package ID',
			value	: 'package_id',
			sortable: true
		},
		{
			text	: 'Tariff ID',
			value	: 'tariff_id',
			sortable: true
		},
		{
			text	: 'Created at',
			value	: 'created_at',
			sortable: true
		},
		{
			text	: 'Access expires at',
			value	: 'access_expires_at',
			sortable: true
		},
		{
			text	: 'Current progress',
			value	: 'currentMaterial',
			sortable: false
		},
		{
			text	: 'Points',
			value	: 'scored_points',
			sortable: true
		},
		{
			text	: 'Status',
			value	: 'status',
			sortable: true
		},
		{
			text    : 'Access',
			value   : 'history'
		},
		{
			text	: 'Actions',
			value	: 'actions',
			sortable: false
		}
	]
}

export function userCourseAccessListTableHead () {
	return [
		{
			text	: 'ID',
			value	: 'id'
		},
		{
			text	: 'Name',
			value	: 'name',
			sort	: (a, b) => {
				if(!a || !b){
					return 0
				}
				
				const nameA = a.data.name.toLowerCase();
				const nameB = b.data.name.toLowerCase();
				
				if (nameA > nameB) {
					return -1
				}
				
				if (nameA < nameB) {
					return 1
				}
				
				return 0
			}
		},
		{
			text	: 'Current progress',
			value	: 'currentMaterial'
		},
		{
			text	: 'Points',
			value	: 'scored_points'
		},
		{
			text	: 'Actions',
			value	: 'actions',
			sortable: false
		}
	]
}

export function userCourseHomeWorkListTableHead () {
	return [
		{
			text	: 'ID',
			value	: 'id'
		},
		{
			text	: 'Started at',
			value	: 'startedAt'
		},
		{
			text	: 'Module',
			value	: 'module'
		},
		{
			text	: 'Points',
			value	: 'points'
		},
		{
			text	: 'Type',
			value	: 'type'
		},
		{
			text	: 'Status',
			value	: 'status'
		},
		{
			text	: 'Actions',
			value	: 'actions',
			sortable: false
		}
	]
}

export function tariffsListTableHead () {
	return [
		{
			text	: 'ID',
			value	: 'id'
		},
		{
			text	: 'Name',
			value	: 'name'
		},
		{
			text	: 'Days',
			value	: 'days'
		},
		{
			text	: 'Actions',
			value	: 'actions',
			sortable: false
		}
	]
}

export function employerList () {
	return [
		{
			name	: '0',
			value	: '0'
		},
		{
			name	: '1-5',
			value	: '1-5'
		},
		{
			name	: '5-20',
			value	: '5-20'
		},
		{
			name	: '20-100',
			value	: '20-100'
		},
		{
			name	: '100+',
			value	: '100+'
		}
	]
}

export function genderList () {
	return [
		{
			name	: this.$t('male'),
			value	: 'male'
		},
		{
			name	: this.$t('female'),
			value	: 'female'
		}
	]
}

export function activityList () {
	return [
		{
			name	: this.$t('student'),
			value	: 'student'
		},
		{
			name	: this.$t('businessman'),
			value	: 'businessman'
		},
		{
			name	: this.$t('employee'),
			value	: 'employee'
		},
		{
			name	: this.$t('freelancer'),
			value	: 'freelancer'
		},
		{
			name	: this.$t('another'),
			value	: 'another'
		}
	]
}

export function userAbFormsTableHead () {
	return [
		{
			text	: 'Course',
			value	: 'course',
			sortable: false
		},
		{
			text	: 'Point A',
			value	: 'point_a',
			sortable: false
		},
		{
			text	: 'Point B',
			value	: 'point_b',
			sortable: false
		},
		{
			text	: 'Rating',
			value	: 'course_rating',
			sortable: false
		},
		{
			text	: 'NPS',
			value	: 'recommendation_rating',
			sortable: false
		},
		{
			text	: 'Sentiment',
			value	: 'sentiment',
			sortable: false
		},
		{
			text	: 'Submitted',
			value	: 'submitted_at',
			sortable: false
		},
		{
			text	: 'Actions',
			value	: 'actions',
			sortable: false
		}
	]
}

export function courseAbFormsTableHead () {
	return [
		{
			text	: 'User',
			value	: 'user',
			sortable: false
		},
		{
			text	: 'Point A',
			value	: 'point_a',
			sortable: false
		},
		{
			text	: 'Point B',
			value	: 'point_b',
			sortable: false
		},
		{
			text	: 'Rating',
			value	: 'course_rating',
			sortable: false
		},
		{
			text	: 'NPS',
			value	: 'recommendation_rating',
			sortable: false
		},
		{
			text	: 'Sentiment',
			value	: 'sentiment',
			sortable: false
		},
		{
			text	: 'Submitted',
			value	: 'submitted_at',
			sortable: false
		},
		{
			text	: 'Actions',
			value	: 'actions',
			sortable: false
		}
	]
}

export function userAdminsListTableHead () {
	return [
		{
			text	: 'Id',
			align	: 'start',
			value	: 'id'
		},
		{
			text	: 'Full name',
			value	: 'fullName'
		},
		{
			text	: 'E-Mail',
			value	: 'email'
		},
		{
			text	: 'Phone',
			value	: 'phone'
		},
		{
			text	: 'Country',
			value	: 'country'
		},
		{
			text	: 'Created time',
			value	: 'create_at'
		},
		{
			text	: 'Status',
			value	: 'status'
		},
		{
			text	: 'Actions',
			value	: 'actions',
			sortable: false
		}
	]
}
